'use strict';
import * as $j_app$002edata$002e$002dPayment$002dDetails from "./app.data.-Payment-Details.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PaymentDetails$EuropeanUnionSEPA(iban, recipient) {
  this.LO = null;
  this.LP = null;
  this.LO = iban;
  this.LP = recipient;
}
export { $c_Lapp_data_PaymentDetails$EuropeanUnionSEPA as $c_Lapp_data_PaymentDetails$EuropeanUnionSEPA };
$p = $c_Lapp_data_PaymentDetails$EuropeanUnionSEPA.prototype = new $j_app$002edata$002e$002dPayment$002dDetails.$h_Lapp_data_PaymentDetails();
$p.constructor = $c_Lapp_data_PaymentDetails$EuropeanUnionSEPA;
/** @constructor */
function $h_Lapp_data_PaymentDetails$EuropeanUnionSEPA() {
}
export { $h_Lapp_data_PaymentDetails$EuropeanUnionSEPA as $h_Lapp_data_PaymentDetails$EuropeanUnionSEPA };
$h_Lapp_data_PaymentDetails$EuropeanUnionSEPA.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_PaymentDetails$EuropeanUnionSEPA) && ((this.LO === x$0.LO) && (this.LP === x$0.LP))));
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "EuropeanUnionSEPA";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.LO;
  }
  if ((n === 1)) {
    return this.LP;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "iban";
  }
  if ((n === 1)) {
    return "recipient";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 0;
});
function $isArrayOf_Lapp_data_PaymentDetails$EuropeanUnionSEPA(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jL)));
}
export { $isArrayOf_Lapp_data_PaymentDetails$EuropeanUnionSEPA as $isArrayOf_Lapp_data_PaymentDetails$EuropeanUnionSEPA };
var $d_Lapp_data_PaymentDetails$EuropeanUnionSEPA = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PaymentDetails$EuropeanUnionSEPA, "app.data.PaymentDetails$EuropeanUnionSEPA", ({
  jL: 1,
  jK: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_PaymentDetails$EuropeanUnionSEPA as $d_Lapp_data_PaymentDetails$EuropeanUnionSEPA };
//# sourceMappingURL=app.data.-Payment-Details$-European-Union-S-E-P-A.js.map
